import axios from "axios";
import { API_BASE_URL } from "../../globalVars";

export default {
  namespaced: true,

  actions: {
    async hydrate({ commit }) {
      const store = this;
      try {
        let response = await axios({
          method: "get",
          url: API_BASE_URL + `/message?lookup=true`,
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`
          }
        });
        const obj = response.data.data;
        let messages = [];

        obj.messageLookups.forEach(function(message) {
          messages.push({
            id: message.id,
            customerId: message.customerId,
            messageType: message.messageType,
            messageBody: message.messageBody,
            isUnread: message.isUnread,
            isSnoozed: message.isSnoozed,
            isArchived: message.isArchived,
            haveNotResponded: message.haveNotResponded,
            messageCreatedAt: message.messageCreatedAt,
            messagesSnoozedUntil: message.messagesSnoozedUntil
          });
        });
        if (messages.length > 0) {
          store.dispatch("entities/messageLookups/insertOrUpdate", {
            data: messages
          });
        }
        store.dispatch("entities/settings/setIsOffline", false);
      } catch (error) {
        store.dispatch("entities/settings/setIsOffline", true);
      }
    },

    async clickMessageLookup(context, { messageLookup, action, actionDate }) {
      let store = this;
      let accountId = store.state.entities.settings.data[1].accountId;
      let userId = store.state.entities.settings.data[1].userId;

      let updateCustomer = {
        id: messageLookup.customerId,
        accountId: accountId,
        isDirty: true,
        isRead: true // to ensure update of viewedAt
      };

      if (action == "messageArchive") {
        actionDate = new Date();
        updateCustomer.messagesArchivedAt = actionDate;
        updateCustomer.messagesSnoozedUntil = null;
        store.dispatch("entities/messageLookups/update", {
          where: tempMessageLookup => {
            return tempMessageLookup.id === messageLookup.id;
          },
          data: { isArchived: true, isSnoozed: false }
        });
      } else if (action == "messageUnarchive") {
        actionDate = null;
        updateCustomer.messagesArchivedAt = actionDate;
        store.dispatch("entities/messageLookups/update", {
          where: tempMessageLookup => {
            return tempMessageLookup.id === messageLookup.id;
          },
          data: { isArchived: false }
        });
      } else if (action == "messageSnooze") {
        updateCustomer.messagesSnoozedUntil = actionDate;
        store.dispatch("entities/messageLookups/update", {
          where: tempMessageLookup => {
            return tempMessageLookup.id === messageLookup.id;
          },
          data: { isSnoozed: true, messagesSnoozedUntil: actionDate }
        });
      }
      
      if (
        !["messageArchive", "messageUnarchive", "messageSnooze"].includes(
          action
        )
      ) {
        store.dispatch("entities/customers/fetchCustomerDataJoins", {
          joins:
            null,
          customerId: messageLookup.customerId,
          startFresh: true
        });
        store.dispatch("entities/users/update", {
          where: userId,
          data: { currentCustomerId: messageLookup.customerId }
        });
        store.dispatch("entities/customers/updateCustomer", updateCustomer);
        store.dispatch("entities/customerLookups/update", {
          where: messageLookup.customerId,
          data: { viewedAt: Date.now() }
        });
        store.dispatch("entities/messageLookups/update", {
          where: tempMessageLookup => {
            return tempMessageLookup.id === messageLookup.id;
          },
          data: { isRead: true }
        });
      }
      // await store.dispatch("entities/accounts/pingAccountLevelDisplay");
    }
  }
};
